import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const listNotifications = async (authToken, { limit = 20 } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  const response = await axios.get(
    `${API_BASE_URL}/api/notifications`,
    { headers, params: { limit } }
  );
  return response.data;
};

const markRead = async (authToken) => {
  const headers = { 'Content-Type': 'application/json' };
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  const response = await axios.post(
    `${API_BASE_URL}/api/notifications/mark-read`,
    {},
    { headers }
  );
  return response.data;
};

const notificationsService = { listNotifications, markRead };
export default notificationsService;
